import React from "react";

const EditableActionField = ({
  selectedtranscriptjson,
  setSelectedTranscriptJson,
  field,
  label,
  rows = 5,
}) => {
  const rawValue = selectedtranscriptjson?.actions?.[field];

  // Convert array to editable text
  const value = Array.isArray(rawValue)
    ? rawValue.join("\n")
    : rawValue || "";

  const handleChange = (e) => {
    const newValue = e.target.value;

    setSelectedTranscriptJson((prev) => ({
      ...prev,
      actions: {
        ...prev.actions,
        [field]: Array.isArray(rawValue)
          ? newValue.split("\n").filter((item) => item.trim() !== "")
          : newValue,
      },
    }));
  };

  return (
    <div className="soap-section">
      {/* <div className="section-label-small">{label}</div> */}

      <textarea
        value={value}
        onChange={handleChange}
        rows={rows}
        className="assessment-textarea"
      />
    </div>
  );
};

export default EditableActionField;